import React, { useState, useEffect } from "react";

const Facts = () => {
    const [lang, setLang] = useState("En");
    useEffect(() => {
        if (localStorage.getItem("language") === "En") {
            setLang("En");
        } else if (localStorage.getItem("language") === "Fr") {
            setLang("Fr");
        }
    }, []);
    return (
        <section class="facts">
            <div class="section-overlay">
                <div class="container">
                    <div class="text-center top-text">
                        <h1>
                            <span>{lang === "Fr" ? `FAITS` : `Cool`}</span>{" "}
                            {lang === "Fr" ? `INTÉRESSANTS` : `Facts`}
                        </h1>
                        <h4>
                            {lang === "Fr" ? `NOS CHIFFRES` : `our numbers`}
                        </h4>
                    </div>

                    <div class="fact-badges">
                        <div class="row">
                            <div class="col-md-3 col-sm-6">
                                <i class="fa fa-briefcase"></i>
                                <h2>
                                    <span>
                                        <strong class="badges-counter">
                                            50
                                        </strong>
                                        +
                                    </span>
                                </h2>
                                <h4>
                                    {lang === "Fr" ? `Projets` : `Projects`}
                                </h4>
                            </div>

                            <div class="col-md-3 col-sm-6">
                                <i
                                    class="far fa-clock"
                                    style={{ fontSize: "90px", color: "#fff" }}
                                ></i>
                                <h2>
                                    <span>
                                        <strong class="badges-counter">
                                            80
                                        </strong>
                                        +
                                    </span>
                                </h2>
                                <h4>
                                    {lang === "Fr"
                                        ? `HEURES DE TRAVAIL`
                                        : `Hours Work`}
                                </h4>
                            </div>

                            <div class="col-md-3 col-sm-6">
                                <i class="fa fa-home"></i>
                                <h2>
                                    <span>
                                        <strong class="badges-counter">
                                            10
                                        </strong>
                                        +
                                    </span>
                                </h2>
                                <h4>{lang === "Fr" ? `BUREAUX` : `Offices`}</h4>
                            </div>

                            <div class="col-md-3 col-sm-6">
                                <i class="fa fa-user"></i>
                                <h2>
                                    <span>
                                        <strong class="badges-counter">
                                            45
                                        </strong>
                                        +
                                    </span>
                                </h2>
                                <h4>{lang === "Fr" ? `CLIENTS` : `Clients`}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Facts;
